import * as React from 'react';

import Box from '@mui/material/Box';

import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';

import { QueryBuilder } from 'shared/base';

import { QuickSyntaxHelper } from './quickSyntaxHelper';
import { useGetFieldOptions } from '../../../hooks/useGetFieldOptions';
import { useGetValueOptions } from '../../../hooks/useGetValueOptions';
import { useTableStateContext } from '../../../hooks/useTableStateContext';
import { extractErrorMessage } from '../../../utils/table';

import { CloudAssetSharedColumns, CloudAssetColumns } from '../../table/columns/cloudAssetColumns';

const prioritizedCloudFields = new Set([
  ...CloudAssetColumns.map((col) => col.field),
  ...CloudAssetSharedColumns.map((col) => col.field),
]);

export const SearchInput = React.memo(({ teamName }: { teamName: string }) => {
  const { error, filter, overwriteFilter } = useTableStateContext();

  const {
    isLoading: isLoadingValueSuggestions,
    updateValueSuggestions,
    valueSuggestions,
  } = useGetValueOptions();
  const {
    fieldOptions,
    isLoading: isLoadingFieldOptions,
    updateFieldOptions,
  } = useGetFieldOptions();

  const setInputValueProxy = (newValue: string | undefined) => {
    overwriteFilter(newValue ?? '');
  };

  const parsedError = React.useMemo(() => extractErrorMessage(error), [error]);

  return (
    <Stack width="100%">
      <Box alignItems="center" display="flex" gap={0.75} height="100%" width="100%">
        <QueryBuilder
          externalQueryString={filter}
          fieldOptions={fieldOptions}
          isError={!!parsedError}
          isLoadingFieldOptions={isLoadingFieldOptions}
          isLoadingValueSuggestions={isLoadingValueSuggestions}
          onChange={setInputValueProxy}
          prioritizedCloudFields={prioritizedCloudFields}
          updateFieldOptions={updateFieldOptions}
          updateValueSuggestions={updateValueSuggestions}
          valueSuggestions={valueSuggestions}
        />
        <Box
          sx={{
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            gap: 0.75,
            height: '100%',
          }}
        >
          <QuickSyntaxHelper teamName={teamName} />
        </Box>
      </Box>

      <Typography color="error" variant="caption">
        {parsedError}
      </Typography>
    </Stack>
  );
});
